import React from "react";

function AsideSection({ testId, title, children }) {
  return (
    <section
      className="min-w-0 rounded-lg border bg-card p-4 shadow-brutal"
      data-testid={testId}
    >
      <h2 className="text-lg font-semibold">{title}</h2>
      <div className="mt-3 min-w-0">{children}</div>
    </section>
  );
}

export default function QuotationPageShell({
  type,
  error,
  conflict,
  onReload,
  primary,
  customer,
  shipping,
  summary,
}) {
  return (
    <main
      className="mx-auto min-w-0 max-w-[1504px] space-y-5 px-4 py-6 sm:px-6 xl:px-8"
      data-testid="quotation-page-shell"
      data-quotation-type={type}
    >
      {error ? (
        <div
          className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-destructive/40 bg-destructive/5 p-4 text-sm text-destructive"
          role="alert"
        >
          <span>{error}</span>
          {conflict ? onReload : null}
        </div>
      ) : null}

      <div className="grid min-w-0 gap-5 lg:grid-cols-[minmax(0,7fr)_minmax(280px,3fr)] lg:items-start">
        <div className="min-w-0 space-y-4" data-testid="quotation-primary-content">
          {primary}
        </div>
        <aside className="min-w-0 space-y-4" data-testid="quotation-supporting-aside">
          <AsideSection testId="quotation-customer-panel" title="2. Customer Information">
            {customer}
          </AsideSection>
          <AsideSection testId="quotation-shipping-panel" title="3. Shipping Cost">
            {shipping}
          </AsideSection>
          <AsideSection testId="quotation-summary-panel" title="4. Summary">
            {summary}
          </AsideSection>
        </aside>
      </div>
    </main>
  );
}
